import Vue from 'vue';
import { DOMManager } from './dom-manager';
import { GTMManagerOptions, RouterOptions } from './interfaces';
import GTMManager from './gtm-manager';

function handleRouterOptions(gtmManager: GTMManager, routerOptions: RouterOptions): void {
  const { vueRouter, entryPath } = routerOptions;
  if (vueRouter && entryPath) {
    vueRouter.beforeEach((to, from, next) => {
      if (to.name === entryPath) {
        gtmManager.enable();
      }
      next();
    });
  }
}

export default {
  install(vue: typeof Vue, options: GTMManagerOptions) {
    const { gtmId, autoInstall } = options;

    const gtmManager = new GTMManager(new DOMManager(), gtmId, autoInstall);
    Vue.prototype.$gtm = gtmManager;

    if (options.routerOptions) {
      handleRouterOptions(gtmManager, options.routerOptions);
    }
  },
};

declare module 'vue/types/vue' {
  interface Vue {
    $gtm: GTMManager;
  }
}
